<highlighted-heading *ngIf="relatedBookings.length > 0" heading="MYBOOKING.RELATED_BOOKINGS.HEADING">
</highlighted-heading>
<div class="related-booking" *ngFor="let booking of relatedBookings">
    <div>{{booking.displayReservedDate}}</div>
    <div>{{booking.reserved_time}}</div>
    <div>{{booking.type | translate }}</div>
    <div>{{booking.workshop.name}}</div>
    <a (click)="navToNear(booking)" class="clickable" [innerHtml]="'MYBOOKING.RELATED_BOOKINGS.SHOW' | translate"></a>
</div>